"use strict";

function UimCommonFunctions() {}

UimCommonFunctions.prototype.API_ENVIRONMENTS = {
    "local" : 'http://localhost:9000/public',
    "dev" : 'https://api-dev.morningstar.com/identity/v1',
    "dev-1" : 'https://api-dev.morningstar.com/identity/v1',
    "qa" : 'https://api-qa.morningstar.com/identity/v1',
    "stg" : 'https://api-stg.morningstar.com/identity/v1',
    "uat" : 'https://api-uat.morningstar.com/identity/v1',
    "prod" : 'https://api.morningstar.com/identity/v1'
};

UimCommonFunctions.prototype.SSO_ENVIRONMENTS = {
    "dev" : 'https://sso-dev.morningstar.com',
    "dev-1" : 'https://sso-dev-1.morningstar.com',
    "qa" : 'https://sso-qa.morningstar.com',
    "stg" : 'https://sso-stg.morningstar.com',
    "uat" : 'https://sso-uat.morningstar.com',
    "prod" : 'https://sso.morningstar.com'
};

UimCommonFunctions.prototype.validateParams = function(params) {
    if (!params.configuration.environment) {
        throw new Error("No environment provided to uim widget");
    }

    if (this.API_ENVIRONMENTS[params.configuration.environment] === undefined) {
        //The STATIC environment is not included in the list as it should not be used by client systems.
        throw new Error("Unknown environment passed. Please choose dev, dev-1, qa, stg, uat, or prod");
    }

    if (!!params.configuration.success && (typeof params.configuration.success !== "function")) {
        throw new Error("Success callback must be a function");
    }

    if (!!params.configuration.error && (typeof params.configuration.error !== "function")) {
        throw new Error("Error callback must be a function");
    }
};

UimCommonFunctions.prototype.showElement = function(element) {
    element.removeClass("hide");
    element.addClass("show");
};

UimCommonFunctions.prototype.hideElement = function(element) {
    element.addClass("hide");
    element.removeClass("show");
};


function isNotAlphaNumeric(char){
    return (char < 48 || (char > 57 && char < 65) || (char > 90 && char < 97) || char > 122);
}


UimCommonFunctions.prototype.passwordMeetsSequentialRequirement = function (password) {
    var sequenceLength = 0;
    var prevChar = password.charCodeAt(0);
    for (var i = 1; i < password.length; i++) {
        if (isNotAlphaNumeric(prevChar) || isNotAlphaNumeric(password.charCodeAt(i))) {
            prevChar = password.charCodeAt(i);
            sequenceLength = 0;
            continue;
        }
        if ((password.charCodeAt(i) - (prevChar + 1)) === 0) {
            sequenceLength < 0 ? sequenceLength = 1 : sequenceLength ++;
        }
        else if ((password.charCodeAt(i) - (prevChar - 1)) === 0) {
            sequenceLength > 0 ? sequenceLength = -1 : sequenceLength --;
        }
        else {
            sequenceLength = 0;
        }
        if (sequenceLength === 3 || sequenceLength === -3) {
            return false;
        }
        prevChar = password.charCodeAt(i);
    }
    return true;
};

UimCommonFunctions.prototype.passwordMeetsRepeatingRequirement = function(password) {
    return (password.match('(.)\\1{3,}') === null);
};

UimCommonFunctions.prototype.validatePassword = function (passwordInput,inputErrorsElement,email) {
    var isValid = false;
    var password = passwordInput[0].value;

    var validPasswordLength = this.showPasswordLength(passwordInput,inputErrorsElement);

    if(validPasswordLength) {
        var specialPresent = this.getIllegalSubstringRegexString(email, password);

        if (password.length >= 8 && (regExpCheck("[A-Z]", password) || regExpCheck("[a-z]", password)) &&
            (regExpCheck("[0-9]", password) || regExpCheck("[!\"#$%&'()*+,-./:;<=>?@^_`{|}~]", password)) &&
            this.passwordMeetsSequentialRequirement(password) &&
            this.passwordMeetsRepeatingRequirement(password) &&
            specialPresent) {
            isValid = true;
        }
        if (isValid) {
            passwordInput.parent().removeClass("error");
            this.hideElement(inputErrorsElement.find(".uim-message.required"));
        } else {
            passwordInput.parent().addClass("error");
            this.showElement(inputErrorsElement.find(".uim-message.required"));
        }
        return isValid;
    }  else {
        return false;
    }

};

function regExpCheck(expression,password){
    return new RegExp(expression).test(password);
}

UimCommonFunctions.prototype.getIllegalSubstringRegexString = function(userName,password){
    var illegalSubstrings = ['MSTAR', 'MORNINGSTAR'];

    if (userName != null) {
        illegalSubstrings.push(userName.toUpperCase().split('@')[0]);
    }

    for (var i = 0; i < illegalSubstrings.length; i++) {
        if(password!=null && (illegalSubstrings[i] == password.toUpperCase() || password.toUpperCase().indexOf(illegalSubstrings[i]) != -1)){
            return false;
        }
    }
    return true;
};

UimCommonFunctions.prototype.showPasswordLength = function (password,inputErrorsElement) {

    var isValid = password[0].value.length < 60 ;

    if (isValid) {
        password.parent().removeClass("error");
        this.hideElement(inputErrorsElement.find(".uim-message.maxlength"));
    } else {
        password.parent().addClass("error");
        this.showElement(inputErrorsElement.find(".uim-message.maxlength"));
    }
    return isValid;
};

UimCommonFunctions.prototype.validateConfirmPassword = function (password, confirmPassword, confirmPasswordElement) {

    var isValid = false;
    if (password[0].value != confirmPassword[0].value ) {
        confirmPassword.parent().addClass("error");
        this.showElement(confirmPasswordElement.find(".uim-message.password_match"));
    } else {
        isValid = true;
        confirmPassword.parent().removeClass("error");
        this.hideElement(confirmPasswordElement.find(".uim-message.password_match"));
    }

    return isValid;
};

UimCommonFunctions.prototype.checkElement = function(element){
    return !!element.hasClass("show");
};

UimCommonFunctions.prototype.validateRequiredField = function (inputField,errorField,errorFieldId) {
    var isEmpty = inputField.val().length === 0;

    if (isEmpty) {
        inputField.parent().addClass("error");
        this.showElement(errorField.find(errorFieldId));
        return false;
    } else {
        inputField.parent().removeClass("error");
        this.hideElement(errorField.find(errorFieldId));
    }

    return !isEmpty;
};
UimCommonFunctions.prototype.getUserPreferredLanguage = function () {
    var language = 'en',
        userLanguages = navigator.languages ? navigator.languages : (navigator.userLanguage || navigator.language || navigator.browserLanguage),
        languagesSupport = ["it", "es", "nl", "fr", "en"],
        pattern = new RegExp(/\-/g),
        langKey = '',
        i = 0;

    // Check the user language is defined or not
    if (typeof userLanguages !== 'undefined') {

        // Check userLanguages array or not and its not array split the language value
        if (userLanguages.constructor !== Array) {
            userLanguages = userLanguages.split('-');
        }

        // Loop through each language and set the correct language
        for (i = 0; i < userLanguages.length; i = i + 1) {
            langKey = userLanguages[i].toLowerCase();

            if (pattern.test(langKey) === true) {
                langKey = langKey.split('-')[0];
            }

            if (languagesSupport.indexOf(langKey) !== -1) {
                language = langKey;
                break;
            }
        }
    }
    return language;
};

UimCommonFunctions.prototype.getUrlParameter = function (parameter) {
    var pageURL = decodeURIComponent(window.location.search.substring(1));
    var urlVariables = pageURL.split('&');

    for (var i = 0; i < urlVariables.length; i++) {
        var parameterName = urlVariables[i].split('=');

        if (parameterName[0] === parameter) {
            return parameterName[1] === undefined ? true : parameterName[1];
        }
    }
};

UimCommonFunctions.prototype.getUserPreferredLocale = function (locale, languagesSupport) {
    var language = 'en';
    // Check the locale is defined or not
    if (typeof locale !== 'undefined') {
        if (locale.toLowerCase() === 'es-es' || locale.toLowerCase() === 'esc') {
            language = 'esc';
        } else if(locale.toLowerCase() === 'fr-ca' || locale.toLowerCase() === 'fc') {
            language = 'fc';
        } else {

            if (languagesSupport.indexOf(locale.toLowerCase()) !== -1) {
                locale = locale.split('-');
                if(locale.length > 0) {
                    language = locale[0].toLowerCase();
                }
            }
        }
    }

    return language;
};
module.exports = new UimCommonFunctions();





//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/common.js
// module id = 15
// module chunks = 0